<template>
    <v-container class="login-container change-password" fluid fill-height>
        <v-flex>
            <v-form @submit.prevent="changePassword">
                <v-card class="elevation-0 pa-5">
                    <v-card-text>
                        <p class="mt-7 mb-9">Per favore inserisci sotto la nuova password e poi salva.</p>
                        <v-text-field
                            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'" @click:append="show = !show"
                            outlined id="password" name="password" placeholder="Password"
                            :type="show ? 'text' : 'password'"
                            v-model="password">
                        </v-text-field>
                        <v-text-field
                            :append-icon="showConfirm ? 'mdi-eye' : 'mdi-eye-off'"
                            @click:append="showConfirm = !showConfirm"
                            outlined id="passwordConfirm" name="passwordConfirm"
                            placeholder="Conferma password"
                            :type="showConfirm ? 'text' : 'password'"
                            v-model="passwordConfirm"></v-text-field>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn rounded x-large color="primary" type="submit" :loading="loading" :disabled="loading" width="100%">SALVA</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-flex>
    </v-container>
</template>

<script>

import UserService from "@/service/UserService";

const userService = new UserService();

export default {
    name: 'ChangePassword',
    props: ['type'],
    data: () => ({
        loading: false,
        password: null,
        show: false,
        showConfirm: false,
        passwordConfirm: null
    }),
    methods: {
        changePassword: function () {
            this.loading = true;
            this.token = this.$route.params.token;
            userService.changePassword(this.password, this.passwordConfirm, this.token).then(() => {
                this.$router.push('/password-changed');
            }, error => {
                this.$root.showError(error.response.data.message, error.response.data);
            }).finally(() =>
                this.loading = false
            );
        }
    }
}
</script>

